<!-- MOBILE -->
<div *ifSize="'SM'">
    <!-- main content -->
    <sticky-free [order]="10"
                 [stickyId]="'store-finder'"
                 class="pos-relative _sticky">
        <div class=" bg-col-w wrap p-t-4 p-b-7">
            <ng-container *ngTemplateOutlet="formTmpl"></ng-container>
        </div>
    </sticky-free>

    <!-- results -->
    <div class="b-b b-col-5 wrap m-t-1 p-b-0">
        <dt class="p2 _tabLink"
            [toggleClass]="'!col-12 _current'"
            [toggleClassBy]="toggleService.getState(['storeFinder', 'map'])"
            (click)="toggleService.open(['storeFinder', 'map'])">{{'Map'|translate}}</dt>
        @if (isResultsView) {
        <dt class="p2 _tabLink"
            [toggleClass]="'!col-12 _current'"
            [toggleClassBy]="toggleService.getState(['storeFinder', 'list'])"
            (click)="toggleService.open(['storeFinder', 'list'])">{{'List'|translate}}</dt>
        }
        @if (!isResultsView) {
        <dt class="p2 _tabLink"
            [toggleClass]="'!col-12 _current'"
            [toggleClassBy]="toggleService.getState(['storeFinder', 'popular'])"
            (click)="toggleService.open(['storeFinder', 'popular'])">{{'Popular'|translate}}</dt>
        }
    </div>
    <!-- map -->
    <div class="ratio-4-5 m-t-5"
         [toggleClass]="'!ng-hide'"
         [toggleClassBy]="toggleService.getState(['storeFinder', 'map'])">
        <ng-container *ngTemplateOutlet="mapTmpl"></ng-container>
    </div>
    <!-- list -->
    <div class="wrap"
         [toggleClass]="'!ng-hide'"
         [toggleClassBy]="toggleService.getState(['storeFinder', 'list'])">
        <ng-container *ngTemplateOutlet="resultsTmpl"></ng-container>
    </div>
    <!-- popular -->
    <div class="wrap p-t-5"
         [toggleClass]="'!ng-hide'"
         [toggleClassBy]="toggleService.getState(['storeFinder', 'popular'])">
        <ng-container *ngTemplateOutlet="popularSearchesTmpl"></ng-container>
    </div>
</div>

<!-- DESKTOP -->
<div *ifSize="'!SM'"
     class="wrap flex p-r-0 _custom-container">
    <!-- main content -->
    <div class="c-4 m-r-0 m-b-0 flex-shrink-0 custom-scrollbar">
        <div class="_detailWrapper"
             [class._open]="isPreviewVisible">
            <div class="w-6 custom-scrollbar p-r-5 p-t-5">
                <ng-container *ngTemplateOutlet="formTmpl"></ng-container>

                <!-- suggested cities -->
                @if (!isResultsView && popularSearches?.length) {
                <div class="m-t-10">
                    <ng-container *ngTemplateOutlet="popularSearchesTmpl"></ng-container>
                </div>
                }

                <!-- results -->
                <ng-container *ngTemplateOutlet="resultsTmpl"></ng-container>
            </div>
            <div class="w-6 p-r-5 p-t-5">
                @if (currentStore) {
                <page-store-finder-details [store]="currentStore"></page-store-finder-details>
                }
            </div>
        </div>
    </div>
    <div class="flex-grow ">
        <div class="_mapWrapper">
            <div class="_map pos-relative">
                <ng-container *ngTemplateOutlet="mapTmpl" />
            </div>
        </div>
    </div>
</div>


<!-- --------------------------- TEMPLATES ----------------------- -->

<!-- TEMPLATE / FORM -->
<ng-template #formTmpl>
    <form method="POST">
        <h1 class="h1 m-b-2-s m-b-2-m"
            *iCms="'title' of content"></h1>
        @if(!isResultsView){
        <form-mui-field class="block m-t-5 pos-relative"
                        [label]="('Postcode, Town or City'| translate)"
                        [hideSideIcon]="true">
            <div class="flex">
                <input type="text"
                       class="w-10"
                       name="address"
                       #addressInput
                       [attr.placeholder]="'Postcode, Town or City' | translate"
                       (keyup)="keyup($event)"
                       [(ngModel)]="address" />
                <action [status]="status"
                        class="bg-col-6 m-l-4 p-t-1 b-radius-4"
                        [style]="{height: '48px', width: '48px'}"
                        (click)="search()">
                    <i class="p-l-3 p-t-2 icon-geo">
                    </i>
                </action>
            </div>
        </form-mui-field>
        <result [status]="status"></result>
        } @else {
        <form-mui-field class="block m-t-5 pos-relative"
                        [label]="('Postcode, Town or City'| translate)"
                        [hideSideIcon]="true">
            <input type="text"
                   name="address"
                   #addressInput
                   [attr.placeholder]="'Postcode, Town or City' | translate"
                   (keyup)="keyup($event)"
                   [(ngModel)]="address" />
            <action class="top-50 right-4"
                    style="position:absolute"
                    [status]="status"
                    aria-label="Reset"
                    (click)="reset()">
                <i class="p-t-2 icon-close"
                   aria-hidden="true">
                </i>
            </action>
        </form-mui-field>
        <result [status]="status"></result>
        }
    </form>
</ng-template>

<!-- TEMPLATE / MAP -->
<ng-template #mapTmpl>
    <div class="fill overflow-hidden">
        <google-map class="fill _custom-container"
                    [fitBounds]="true"
                    [stores]="mapModels"
                    [maxZoom]="client.sizeId < 2 ? 8 : isUserSearch ? 13 : 8"
                    [markerLimit]="isUserSearch ? showLimit : 1000"
                    (storeSelected)="onStoreMarkerClicked($event)" />
    </div>
</ng-template>

<!-- TEMPLATE / RESULTS -->
<ng-template #popularSearchesTmpl>
    <p class="s2 m-b-5"
       *iCms="'popularSearchesTitle' of content; skipEmpty:true"></p>
    @for (item of popularSearches; track $index; let first = $first) {
    <p (click)="searchFor(item.name)"
       [ngClass]="{'m-t-4': !first}"
       class="cursor-pointer p2">{{item.name}}</p>
    }
</ng-template>

<!-- TEMPLATE / RESULTS -->
<ng-template #resultsTmpl>
    @if (isResultsView) {
    <div class="m-t-5-s m-t-5-m m-t-10-l m-t-10-x">
        @for (store of findableModels; track store.id; let last= $last) {
        <div [ngClass]="last ? 'b-b' : ''"
             class="cursor-pointer flex flex-middle p-t-3 p-b-3 b-t b-col-4"
             (click)="previewStore(store)">
            <page-store-finder-store [store]="store"
                                     class="block flex-grow"></page-store-finder-store>
            <aside class=" m-l-5"><i class="icon-chevron-right"></i></aside>
        </div>
        }
    </div>
    }
</ng-template>
